import { useState } from "react";
import Cookies from "universal-cookie";
import Swal from "sweetalert2";
import axios from "axios";
// @mui
import { Stack, TextField, Typography, Box } from "@mui/material";
import { LoadingButton } from "@mui/lab";

export default function LoginForm() {
  const cookie = new Cookies();

  const redirige = () => {
    const tipoUsuario = cookie.get("tipoUsuario");
    const correo = cookie.get("correo");

    switch (tipoUsuario) {
      case 1:
      case 5:
      case 6:
        window.location.href = `/#/InfoCertificados/${correo}`;
        break;
      case 2:
        window.location.href = "/#/InfoTesoreria";
        break;
      case 3:
        Swal.fire(
          "Acceso restringido",
          "Solo tiene permisos a la consulta pública, comuníquese con el administrador del sistema.",
          "warning"
        );
        break;
      case 8:
        window.location.href = `/#/consultaSAE`;
        break;
      default:
        break;
    }
  };

  const [correoElectronico, setCorreoElectronico] = useState("");
  const [contrasena, setContrasena] = useState("");
  const [loading, setLoading] = useState(false);

  const postData = async () => {
    setLoading(true);
    try {
      const { data } = await axios.post(
        "https://middlewarebackprd.azurewebsites.net/api/v1/AutenticaFormulario",
        {
          correo: correoElectronico,
          contrasena,
        },
        {
          auth: {
            username: "admin.icontec@icontec.org",
            password: "quAngEraMuSTerGerEDE",
          },
        }
      );

      if (data.length > 0) {
        const respuesta = data[0];

        cookie.set("nombre", respuesta.nombre, { path: "/" });
        cookie.set("identificacion", respuesta.identificacion, { path: "/" });
        cookie.set("correo", respuesta.correo, { path: "/" });
        cookie.set("ut", respuesta.ut, { path: "/" });
        cookie.set("tipoUsuario", respuesta.tipoUsuario, { path: "/" });
        cookie.set("cargo", respuesta.cargo, { path: "/" });

        Swal.fire({
          title: "¡Bienvenido!",
          text: respuesta.nombre,
          icon: "success",
          timer: 4000,
        }).then(redirige);
      } else {
        Swal.fire("Error", "Usuario o contraseña incorrectos", "error");
      }
    } catch (error) {
      console.error(error);
      Swal.fire("Error", "Intente ingresar de nuevo", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      initial={{ opacity: 0, y: 40 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      sx={{
        p: 4,
        borderRadius: "16px",
        boxShadow: "0px 6px 20px rgba(0,0,0,0.15)",
        background: "linear-gradient(135deg, #ffffff, #f4f7fb)",
      }}
    >
      <Typography
        variant="h5"
        fontWeight="bold"
        textAlign="center"
        gutterBottom
        sx={{ color: "#0078D4" }}
      >
        Iniciar Sesión
      </Typography>

      <Stack spacing={3}>
        <TextField
          name="email"
          label="Correo electrónico"
          variant="outlined"
          value={correoElectronico}
          onChange={(e) => setCorreoElectronico(e.target.value)}
          sx={{
            "& .MuiOutlinedInput-root": {
              borderRadius: "12px",
              "&:hover fieldset": { borderColor: "#0078D4" },
              "&.Mui-focused fieldset": { borderColor: "#0078D4" },
            },
          }}
        />

        <TextField
          name="password"
          type="password"
          label="Contraseña"
          variant="outlined"
          value={contrasena}
          onChange={(e) => setContrasena(e.target.value)}
          sx={{
            "& .MuiOutlinedInput-root": {
              borderRadius: "12px",
              "&:hover fieldset": { borderColor: "#0078D4" },
              "&.Mui-focused fieldset": { borderColor: "#0078D4" },
            },
          }}
        />
      </Stack>

      <LoadingButton
        fullWidth
        size="large"
        type="submit"
        variant="contained"
        loading={loading}
        onClick={postData}
        sx={{
          mt: 4,
          py: 1.5,
          fontWeight: "bold",
          borderRadius: "12px",
          background: "linear-gradient(90deg, #0078D4 0%, #00A4EF 100%)",
          boxShadow: "0 4px 14px rgba(0,120,212,0.4)",
          "&:hover": {
            background: "linear-gradient(90deg, #005a9e 0%, #0078D4 100%)",
            transform: "scale(1.03)",
            boxShadow: "0 6px 18px rgba(0,90,158,0.5)",
          },
        }}
      >
        Entrar
      </LoadingButton>
    </Box>
  );
}
